import React from "react";


function OpensourceLicense () {

    const des = "본 프로젝트는 React와 Typescript를 포함한 여러 오픈소스들을 사용해 만들어졌어요.\n전 세계의 오픈소스 개발자 분들 덕에 저희 서비스가 유지됩니다♡"
    const MIT = `Copyright <YEAR> <COPYRIGHT HOLDER>\n\nPermission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the “Software”), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:\n\nThe above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.\n\nTHE SOFTWARE IS PROVIDED “AS IS”, WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.`
    const meta = "\nHomepage"
    const BSD3 = `Copyright <YEAR> <COPYRIGHT HOLDER>\n\nRedistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:\n\n1. Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.\n\n2. Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.\n\n3. Neither the name of the copyright holder nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.\n\nTHIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.`
    const apache2 = `Copyright [yyyy] [name of copyright owner]\n\nLicensed under the Apache License, Version 2.0 (the "License");you may not use this file except in compliance with the License. You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0\n\nUnless required by applicable law or agreed to in writing, software distributed under the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions and limitations under the License.`
    
    return(
        <div className="License-box">
            <div className="License-title">
                <a>오픈소스 라이선스 고지</a>
            </div>
            <div className="License-des">
                <a>{des}</a>
            </div>
                <div>


                <div className="License-Header">
                    <h1>MIT-License</h1>
                </div>
                <div className="License-List">
                    <details open>
                        <summary>MIT-License</summary>
                        <a>{MIT}</a>
                    </details>
                    <details>
                        <summary>react</summary>
                        <a href="https://github.com/facebook/react" target="_blank" className="License-Link">Github</a>
                        <a href="https://react.dev" target="_blank" className="License-Link">{meta}</a>
                    </details>
                    <details>
                        <summary>react-dom</summary>
                        <a href="https://react.dev" target="_blank" className="License-Link">Homepage</a>
                    </details>
                    <details>
                        <summary>@testing-library/dom</summary>
                        <a href="https://github.com/testing-library/dom-testing-library" target="_blank" className="License-Link">Github</a>
                    </details>
                    <details>
                        <summary>@testing-library/jest-dom</summary>
                        <a href="https://github.com/testing-library/jest-dom" target="_blank" className="License-Link">Github</a>
                    </details>
                    <details>
                        <summary>@testing-library/react</summary>
                        <a href="https://github.com/testing-library/react-testing-library" target="_blank" className="License-Link">Github</a>
                    </details>
                    <details>
                        <summary>@testing-library/uesr-event</summary>
                        <a href="https://github.com/testing-library/user-event" target="_blank" className="License-Link">Github</a>
                    </details>
                    <details>
                        <summary>@types/jest</summary>
                        <a href="https://github.com/DefinitelyTyped/DefinitelyTyped/tree/master/types/jest" target="_blank" className="License-Link">Github</a>
                    </details>
                    <details>
                        <summary>@types/node</summary>
                        <a href="https://github.com/DefinitelyTyped/DefinitelyTyped/tree/master/types/node" target="_blank" className="License-Link">Github</a>
                    </details>
                    <details>
                        <summary>@types/react-dom</summary>
                        <a href="https://github.com/DefinitelyTyped/DefinitelyTyped/tree/master/types/react-dom" target="_blank" className="License-Link">Github</a>
                    </details>
                    <details>
                        <summary>react-native-oss-License</summary>
                        <a href="https://github.com/k-tomoyasu/react-native-oss-license" target="_blank" className="License-Link">Github</a>
                    </details>
                    <details>
                        <summary>react-router-dom</summary>
                        <a href="https://github.com/remix-run/react-router" target="_blank" className="License-Link">Github</a>
                    </details>
                    <details>
                        <summary>react-scripts</summary>
                        <a href="https://github.com/facebook/create-react-app" target="_blank" className="License-Link">Github</a>
                    </details>
                    <details>
                        <summary>react-transition-group</summary>
                        <a href="https://github.com/reactjs/react-transition-group" target="_blank" className="License-Link">Github</a>
                    </details>
                </div>


                <div className="License-Header">
                    <h1>BSD-3-Clause</h1>
                </div>
                <div className="License-List">    
                    <details open>
                        <summary>BSD-3-Clause</summary>
                        <a>{BSD3}</a>
                    </details>
                    <details>
                        <summary>react-transition-group</summary>
                        <a href="https://github.com/reactjs/react-transition-group" target="_blank" className="License-Link">Github</a>
                    </details>
                </div>
                


                <div className="License-Header">
                    <h1>Apache-2.0</h1>
                </div>
                <div className="License-List">    
                    <details open>
                        <summary>Apache-2.0</summary>
                        <a>{apache2}</a>
                    </details>
                    <details>
                        <summary>typescript</summary>
                        <a href="https://typescriptlang.org" target="_blank" className="License-Link">Homepage</a>
                    </details>
                    <details>
                        <summary>web-vitals</summary>
                        <a href="https://github.com/GoogleChrome/web-vitals" target="_blank" className="License-Link">Github</a>
                    </details>
                    <details>
                        <summary>wrangler</summary>
                        <a href="https://github.com/cloudflare/workrs-sdk" target="_blank" className="License-Link">Github</a>
                    </details>
                </div>
            </div>
        </div>

    )
}

export default OpensourceLicense;